(function () {
  var STORAGE_KEY = 'ff_recently_viewed_products';
  var MAX_STORED = 12;

  function getStored() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function trackCurrentProduct(handle) {
    if (!handle) return;
    var stored = getStored().filter(function (h) {
      return h !== handle;
    });
    stored.unshift(handle);
    setStored(stored.slice(0, MAX_STORED));
  }

  function extractCard(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.ff-product-card');
  }

  function initRecentlyViewed(section) {
    if (section.dataset.ffRecentInit === 'true') return;
    section.dataset.ffRecentInit = 'true';

    var currentHandle = section.dataset.currentHandle || '';
    var limit = parseInt(section.dataset.productsToShow, 10) || 4;
    var cardSectionId = section.dataset.cardSectionId;
    var track = section.querySelector('[data-ff-product-track]');

    trackCurrentProduct(currentHandle);

    if (!track || !cardSectionId) return;

    var handles = getStored()
      .filter(function (h) {
        return h && h !== currentHandle;
      })
      .slice(0, limit);

    if (handles.length === 0) return;

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '?section_id=' + cardSectionId)
          .then(function (response) {
            return response.ok ? response.text() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (results) {
      var added = false;

      results.forEach(function (html) {
        if (!html) return;
        var card = extractCard(html);
        if (!card) return;

        var item = document.createElement('li');
        item.className = 'ff-product-showcase__item';
        item.appendChild(card);
        track.appendChild(item);
        added = true;
      });

      if (added) {
        section.hidden = false;
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ff-recently-viewed').forEach(initRecentlyViewed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ff-recently-viewed') || event.target;
    if (section && section.classList && section.classList.contains('ff-recently-viewed')) {
      delete section.dataset.ffRecentInit;
      section.hidden = true;
      var track = section.querySelector('[data-ff-product-track]');
      if (track) track.innerHTML = '';
      initRecentlyViewed(section);
    }
  });
})();
